import { AxiosError } from 'axios';

const badGateway = 502;
const serviceUnavailable = 503;
const gatewayTimeout = 504;
const retryErrors = [badGateway, serviceUnavailable, gatewayTimeout];

export let log = (message: string) => console.log(message);

export function setLog(newLog: (message: string) => void) {
  log = newLog;
}

export interface ITimeoutParams {
  retries?: number | null | undefined;
}

export const requestAndRetry = async (
  tryRequest: () => Promise<{ result: any; error: AxiosError }>,
  retries: number | null | undefined = 0,
  route: string,
): Promise<any> => {
  let result: any;
  let error: AxiosError;

  while (!result && retries >= 0) {
    ({ result, error } = await tryRequest());
    if (error) {
      if (error.response) {
        log(responseError(error.message, error.response.status, route, retries));
        if (!retryOnError(error.response.status)) {
          break;
        }
      } else if (error) {
        log(timeoutError(route, retries));
      }
    }
    retries--;
  }

  if (error) {
    throw error;
  }

  return result;
};

const retryOnError = (status: number) => retryErrors.indexOf(status) !== -1;

const responseError = (message: string, status: number, route: string, retries: number): string =>
  `An error occurred when fetching from ${route}: ${status} (${retries} retries left.)\nError Message: ${message}`;

const timeoutError = (route: string, retries: number): string =>
  `A timeout error occurred when fetching from ${route}. (${retries} retries left.)`;
